import { Link, Navigate, NavLink, useLocation } from "react-router-dom"
import React, { useEffect, useRef, useState } from 'react';
import { routes } from "../../../routes/router";
import { } from "@heroicons/react/16/solid";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useNavigate } from 'react-router-dom';

export const Header = () => {
    const headerRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const { pathname } = useLocation();
    const [mobileNav, setMobileNav] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({ top: 0 });
        const handleScroll = () => {
            const headerHeight = headerRef.current ? headerRef.current.offsetHeight : 0;
            if (window.scrollY > headerHeight) {
                setIsScrolled(true);

            } else {
                setIsScrolled(false);

            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [pathname]);

    const handleMobileNav = () => {
        setMobileNav(true)
    }
    const handleMobileNavClose = () => {
        setMobileNav(false)
    }
    const handleRegister = () => {
        navigate('register')
    }

    
    return (
        <header className={`header header-sticky ${isScrolled ? 'scrolled' : ''}`}
            ref={headerRef} >
            <div className="container">
                <div className="header-left">
                    <button className="button-humberger" onClick={handleMobileNav}>
                        <Bars3Icon />
                    </button>
                    <Link to='/' className="logo" title="mygenglobal"><img src="/header/logo.svg" alt="logo" className="header-logo" /></Link></div>
                <div className="header-right">
                    <nav className={`header-nav ${mobileNav ? 'mobile-nav-open' : ''}`}>
                        <ul className="header-nav-list">
                            {
                                routes.map((navItem, i) => (

                                    navItem.label ? (
                                        <li key={i} className="header-nav-list-item" onClick={handleMobileNavClose}>
                                           {
                                                <NavLink to={navItem.path} className={({ isActive }) => isActive ? "active" : ""}>
                                                {navItem.label}
                                            </NavLink>
                                           }
                                            {
                                                navItem.children && navItem.children.length > 0 && (
                                                    <ul className="sub-nav-list">
                                                        {
                                                            navItem.children.map((subItem, i) => (
                                                               subItem.label? (
 <li key={i}>
                                                                    <NavLink to={subItem.path} className={({ isActive }) => isActive ? "active" : ""}>
                                                                        {subItem.label}
                                                                    </NavLink>
                                                                </li>
                                                               ): null
                                                            ))
                                                        }

                                                    </ul>
                                                )
                                            }
                                        </li>
                                    )
                                        : null

                                ))
                            }
                        </ul>
                    </nav>
                    <button className="button button-medium button-primary" onClick={handleRegister}>Registration</button>
                </div>
            </div>

        </header>
    )
}

export default Header